const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

export const buildApiUrl = (path = '') => `${API_BASE}${path}`;

export async function apiJson(path, { method = 'GET', body, token, headers = {} } = {}) {
  const res = await fetch(buildApiUrl(path), {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...headers,
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `Request failed with status ${res.status}`);
  }
  return res.json();
}
